// Copyright (c) 2020 WiseTime. All rights reserved.

import "./sentry"
import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { I18nProvider } from "@lingui/react"
import App from "App"
import { store } from "app/store"
import * as serviceWorker from "serviceWorker"
import { i18n } from "@lingui/core"
import { activateI18n } from "locales/i18nUtil"

activateI18n()

ReactDOM.render(
  <Provider store={store}>
    <I18nProvider i18n={i18n}>
      <App/>
    </I18nProvider>
  </Provider>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
